export const SETTLEMENT_CREATE_RESET = 'SETTLEMENT_CREATE_RESET'
export const SETTLEMENT_CREATE_SET_CREATED = 'SETTLEMENT_CREATE_SET_CREATED'
export const SETTLEMENT_CREATE_SET_ERROR = 'SETTLEMENT_CREATE_SET_ERROR'
export const SETTLEMENT_CREATE_SET_VIOLATIONS = 'SETTLEMENT_CREATE_SET_VIOLATIONS'
export const SETTLEMENT_CREATE_TOGGLE_LOADING = 'SETTLEMENT_CREATE_TOGGLE_LOADING'
